// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import { KEY_PREFIX } from 'config';
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import instrumentsCalendarReducer from './slices/instrumentsCalendar';
import classroomCalendarReducer from './slices/classroomCalendar';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: `${KEY_PREFIX}-`
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    instrumentsCalendar: instrumentsCalendarReducer,
    classroomCalendar: classroomCalendarReducer
});

export default reducer;
